import {ChangeDetectionStrategy, Component} from '@angular/core';
import {IconComponent} from '../icon/icon.component';
import {TranslatePipe} from '@ngx-translate/core';

@Component({
  selector: 'ucs-auth-failure',
  templateUrl: './auth-failure.component.html',
  styleUrls: ['./auth-failure.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IconComponent, TranslatePipe]
})
export class AuthFailureComponent {
}
